// Vue
import { Component, Watch } from "vue-property-decorator";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
// Enums
import { PITLanguage, PITRegions } from "#/common/enums/PITMarket";

import { Api } from "#/api";
import { Store } from "#/store";
import { PitData } from "#/common/models/module/PitData";
import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
  },
})
export class PitModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  private data: PitData | null = null;
  private session: any = {};
  private identifier: string = "";
  private selectedMarketLanguage: string = "de/de_DE";
  private marketLanguageOptions: any[] = [];
  private isLoading: boolean = true;
  private groupedData: any = [];
  private selectedCode: any = null;

  public groupeData() {
    const sorted = this.data?.details.sort(this.sortCode);
    this.groupedData = sorted!.reduce(
      (result, item) => ({
        ...result,
        [(item as { code: string }).code[0]]: [
          ...(result[(item as { code: string }).code[0]] || []),
          item,
        ],
      }),
      {}
    );
  }

  private sortCode(a: any, b: any) {
    // This is the case for Unimog and some other vehicletypes
    if (a.code === undefined || b.code === undefined) {
      const splita = a._links?.self.href.split("/");
      a.code = splita[splita.length - 2].toUpperCase();
      const splitb = b._links?.self.href.split("/");
      b.code = splitb[splitb.length - 2].toUpperCase();
    }

    return a.code.localeCompare(b.code);
  }

  public getImageBasePath(imageHref: string) {
    return Store.instance.ui.pitApiUrl + imageHref.split("v1.0/")[1];
  }

  public selectCode(codeEntry) {
    this.selectedCode = codeEntry;
  }

  public created() {
    this.initialize();
  }

  @Watch("selectedMarketLanguage")
  public async selectedMarketLanguageWatcher() {
    this.isLoading = true;
    await this.loadPITDAta();
    this.isLoading = false;
  }

  public async loadPITDAta() {
    this.data = await Api.pitService.getData(
      this.identifier,
      this.selectedMarketLanguage
    );
    this.groupeData();
  }

  public async initialize() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("token")) {
      let token = urlParams.get("token")!;

      this.isLoading = true;
      this.session = await Api.pitService.getSession(token);

      if (
        this.session.completeFilter["BAUREIHE"] != undefined &&
        (this.session.completeFilter["PRODUKTGRUPPE"] == undefined ||
          this.session.completeFilter["MODELLGENERATION"] == undefined)
      ) {
        // This is the case for Unimog and some other vehicletypes
        this.identifier =
          `${this.session.completeFilter["BAUREIHE"]}`.toLowerCase();
      } else {
        this.identifier =
          `${this.session.completeFilter["BAUREIHE"]}/${this.session.completeFilter["MODELLGENERATION"]}/${this.session.completeFilter["PRODUKTGRUPPE"]}`.toLowerCase();
      }
    }
    const marketLanguageOptions = await Api.pitService.getMarketVersionData();
    this.marketLanguageOptions = marketLanguageOptions.filter((item: any) => {
      let market = item.key.split("/")[0];
      return this.getSelectedCountryForPit() === market;
    });

    const marketIdentifier =
      this.getSelectedCountryForPit() + "/" + this.getSelectedLanguageForPit();
    if (
      marketLanguageOptions.some(
        (option: any) => option.key === marketIdentifier
      )
    ) {
      this.selectedMarketLanguage = marketIdentifier;
    } else if (
      marketLanguageOptions.some(
        (option: any) =>
          option.key === this.getSelectedCountryForPit() + "/" + PITLanguage.EN
      )
    ) {
      this.selectedMarketLanguage =
        this.getSelectedCountryForPit() + "/" + PITLanguage.EN;
    } else {
      this.selectedMarketLanguage =
        this.getSelectedCountryForPit() + "/" + PITLanguage.DE;
    }

    await this.loadPITDAta();

    this.isLoading = false;
  }

  private getSelectedCountryForPit() {
    const country = Store.instance.ui.appCurrentCountry;
    return PITRegions[country] ?? PITRegions.GLOBAL;
  }

  private getSelectedLanguageForPit() {
    const language = Store.instance.ui.appCurrentLanguage;
    return PITLanguage[language.toLocaleUpperCase()] ?? PITLanguage.EN;
  }
}
